import MainContentUpload from "./mainContent"

const SongUploader = ({ selectedContent, updateContent }) => {

    const formattedSong = {
        ...selectedContent,
        contentId: selectedContent.key ?? null,
        contentType: "song",
    }

    const handleContentUpdate = (content) => {
        updateContent(content)
    }

    return (
        <div>
            <MainContentUpload selectedContent={formattedSong} updateContentChild={handleContentUpdate} />
        </div>
    )
}

export default SongUploader;
